import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-termeni-conditii',
  templateUrl: './termeni-conditii.component.html',
  styleUrls: ['./termeni-conditii.component.scss']
})


export class TermeniConditiiComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
